"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoDimensions = void 0;
const sendLoggingEvent_1 = require("./sendLoggingEvent");
const loggingTypes_1 = require("../types/loggingTypes");
class GeoDimensions {
    constructor() {
        this._geoUserCity = sendLoggingEvent_1.DEFAULT_VALUE;
        this._geoUserLocation = loggingTypes_1.EMPTY_LOCATION;
        this.getGeoUserLocation();
        // this.fetchCityFromIP();
    }
    static getInstance() {
        if (!GeoDimensions.instance) {
            GeoDimensions.instance = new GeoDimensions();
        }
        return GeoDimensions.instance;
    }
    get geoUserCity() {
        return this._geoUserCity;
    }
    get geoUserLocation() {
        return this._geoUserLocation;
    }
    getGeoUserLocation() {
        var _a;
        if (!(navigator === null || navigator === void 0 ? void 0 : navigator.geolocation))
            return;
        (_a = navigator.permissions) === null || _a === void 0 ? void 0 : _a.query({ name: "geolocation" }).then((state) => {
            if (state.state === "granted" || state.state === "denied") {
                navigator.geolocation.getCurrentPosition((position) => {
                    this._geoUserLocation = {
                        latitude: position.coords.latitude.toString(),
                        longitude: position.coords.longitude.toString(),
                    };
                }, (error) => {
                    console.log("Error getting geolocation:", error.message);
                });
            }
        }).catch((err) => console.log("Error checking geolocation permissions:", err));
    }
    fetchCityFromIP() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetch("https://ipapi.co/json/");
                const data = yield response.json();
                this._geoUserCity = data.city || sendLoggingEvent_1.DEFAULT_VALUE;
            }
            catch (error) {
                console.log("Error in fetchCityFromIP", error);
                this._geoUserCity = sendLoggingEvent_1.DEFAULT_VALUE;
            }
        });
    }
}
exports.GeoDimensions = GeoDimensions;
